import React, { useCallback, useEffect, useState } from 'react'
import Toast, { showToast } from '../../Components/Toast';
import Header from './Header';
import Add from './Add';
import Edit from './Edit';
import Loader from '../../Components/Loader';
import Table from '../../Components/Table';
import { EuiImage, EuiPageBody } from '@elastic/eui';
import axios from '../../axiosService';
import ConfirmModel, { showDialog, hideDialog } from '../../Components/ConfirmModel'
import moment from "moment";

function Articles() {
  const server = process.env.REACT_APP_APIPATH
  const authtoken = localStorage.getItem("authtoken");
  const config = {
    headers: {
      'Authorization': "Bearer " + authtoken
    }
  }

  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [EditData, setEditData] = useState({});

  const [IsLoading, setIsLoading] = useState(false)
  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const [Data, setData] = useState([])

  function convertDateToIndianFormat(utcTimestamp) {
    const date = new Date(utcTimestamp);

    // Calculate the offset in minutes
    const offsetInMinutes = date.getTimezoneOffset();

    // Adjust for IST by subtracting the offset from the Date object
    const istDateTime = new Date(date.getTime() - offsetInMinutes * 60000);

    // Format the IST datetime
    const formattedISTDateTime = istDateTime.toLocaleString("en-IN", {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: "Asia/Kolkata" // Ensure IST for formatting
    }).replace(',', '').toUpperCase();;

    return formattedISTDateTime;
  }

  function convertDateToISTDate(utcTimestamp) {
    const date = new Date(utcTimestamp);

    // Calculate the offset in minutes
    const offsetInMinutes = date.getTimezoneOffset();

    // Adjust for IST by subtracting the offset from the Date object
    const istDateTime = new Date(date.getTime() - offsetInMinutes * 60000);

    return istDateTime;
  }

  const columns = [
    { field: 'rowNumber', name: 'Row Number', sortable: true },
    { field: 'causeName', name: 'Cause Name', sortable: true },
    { field: 'eventName', name: 'Event Name', sortable: true },
    {
      field: 'eventDate', name: 'Event Date', sortable: true, render: (EventDate) => (
        <span>{convertDateToIndianFormat(EventDate)}</span>
      )
    },
    {
      field: 'photo', name: 'Banner Image', render: (imgUrl) => (
        <EuiImage size="m" src={server + imgUrl} alt='No Image Found' allowFullScreen hasShadow />
      )
    }
  ]

  // delete function
  const deleteRecord = async (record) => {
    try {
      startLoading();
      const response = await axios.delete(`${server}api/Event/` + record.eventId, config);
      if (response.status === 200) {
        filldata()
        showToast("Event Deleted", "success", 2000);
      }
      stopLoading();
      hideDialog();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  };

  // edit function
  const editRecord = async (record) => {
    try {
      startLoading();
      const response = await axios.get(`${server}api/Event/` + record.eventId, config)
      if (response.status === 200) {
        const data = await response.data;
        setEditData({ ...data, eventDate: moment(convertDateToISTDate(data.eventDate)) });
        setIsEditing(true);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      console.error(error);
      stopLoading();
    }
  };

  //declare edit and delete buttons
  const actions = [
    {
      name: 'Edit',
      isPrimary: true,
      description: 'Edit this Record',
      icon: 'pencil',
      type: 'icon',
      onClick: editRecord,
      'data-test-subj': 'action-edit',
    }, {
      name: "Delete",
      description: 'Delete this Record',
      icon: 'trash',
      color: 'danger',
      type: 'icon',
      onClick: showDialog,
      isPrimary: true,
      'data-test-subj': 'action-delete',
    }
  ];

  //add buttons to columns
  const columnsWithActions = [
    ...columns,
    {
      name: 'Actions',
      actions,
    },
  ];

  //get table data
  const filldata = async () => {
    try {
      startLoading();
      const response = await axios.get(`${server}api/Event`, config);
      if (response.status === 200) {
        const data = await response.data;
        setData(data);
      }
      stopLoading();
    } catch (error) {
      showToast(error.toString(), "error", 15000);
      stopLoading();
    }
  }

  useEffect(() => {
    filldata();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!isEditing && !isAdding) {
      filldata()
    }
    // eslint-disable-next-line
  }, [isAdding, isEditing]);

  useEffect(() => {
    if (!isEditing) {
      setEditData({});
    }
  }, [isEditing]);

  return (
    <EuiPageBody style={{ width: "100%", padding: "10px" }}>
      <Loader IsLoading={IsLoading} />
      {!isAdding && !isEditing && (
        <>
          <Header
            headerText="Event Master"
            setIsAdding={setIsAdding}
          />
          <Table data={Data} columns={columnsWithActions} height={70} />
        </>
      )}
      {isAdding && (
        <Add
          server={server}
          authtoken={authtoken}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsAdding={setIsAdding}
        />
      )}
      {isEditing && (
        <Edit
          server={server}
          authtoken={authtoken}
          EditData={EditData}
          startLoading={startLoading}
          stopLoading={stopLoading}
          setIsEditing={setIsEditing}
        />
      )}
      <Toast />
      <ConfirmModel title="Delete Record ?" text="The Record will be Deleted. Please Proceed With Caution !" confirmButton="Delete" cancelButton="Cancel" confirmFunction={deleteRecord} />
    </EuiPageBody>
  )
}

export default Articles
